import { breakpoints } from '../../scripts/utils';
import { toggleAccordion } from '../accordion/accordion';

const tableOfContentJsClass = 'js-table-of-content';

const tableOfContentElement = document.querySelector('.' + tableOfContentJsClass) as HTMLElement;

if (tableOfContentElement) {
    window.addEventListener('load', () => {
        // If the screen is large enough
        if (window.innerWidth >= breakpoints.xxl) {
            // Open the accordion
            toggleAccordion(null, tableOfContentElement);
        }
    });
}